module.exports = __webpack_public_path__ + "static/media/codeRainbowBalls.ba33aca4.png";